import { FormikHelpers } from "formik";
import { useCreateAtmModel } from "./api/createAtmModel";
import AtmModelForm from "./AtmModelForm";


const CreateAtmModel = ({handleCloseModal}: CreateModelProps)  => {
  const createAtmModelMutation = useCreateAtmModel({data: {}});

  const initialValues: IPostNewAtmModel = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewAtmModel, { setSubmitting }: FormikHelpers<IPostNewAtmModel>): Promise<void> => {
    try {
      await createAtmModelMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AtmModelForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateModelProps {
  handleCloseModal: () => void;
}

export default CreateAtmModel;